<div *ngIf="!!ecNetwork && canReadCommunity" fxLayout="row" fxLayoutGap="24px" class="ec-resources-container p-20">
    <div class="resource-tree">
        <app-ec-resource-tree [network]="ecNetwork"
                              (selectionChange)="onSelectResource($event)">
        </app-ec-resource-tree>
    </div>
    <div *ngIf="resource" class="ec-resources-main-panel">
        <div *ngIf="communitySelected && !(isAdvUser|async)" fxLayout="row" fxLayoutAlign="end" class="mb-16">
            <button app-primary-button
                    [disabled]="!canCreateResource"
                    (click)="onClickCreatePodNew()">
                <app-icon name="fal-plus-square"></app-icon>
                {{ 'Create new POD'|i18n }}
            </button>
        </div>
        <div fxLayout="column" fxLayoutGap="16px">
            <div fxLayout="row" fxLayoutGap="20px">
                <div *ngIf="communitySelected" fxLayout="column" fxLayoutGap="36px"
                     class="ec-details-panel">
                    <ng-container *appVar="asEnergyCommunity(resource.data) as ec">
                        <div fxLayout="column" fxLayoutGap="16px">
                            <div fxLayout="column" class="mt-16" fxLayoutGap="16px">
                                <span class="txt-h-24-7">{{ resource.name }}</span>
                            </div>
                            <div fxLayout="column" fxLayoutGap="16px">
                                <span class="txt-h-16-4">
                                    {{ {type: resource.type, sub_type: resource.sub_type}|entityType|i18n }}
                                </span>
                            </div>
                            <div fxLayout="column" fxLayoutGap="16px"
                                 class="ec-details-panel-2 pt-10 pl-16 pr-16 pb-28">
                                <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="space-between">
                                    <div fxFlex="50" class="txt-h-18-7">{{ 'Technical details'|i18n }}</div>
                                    <div fxLayout="row" *ngIf="!(isAdvUser|async)">
                                        <button app-small-ghost-button
                                                class="mr-10"
                                                [disabled]="!communityUpdatable"
                                                (click)="onClickEditCommunity()">
                                            <app-icon name="fal-pencil-alt"></app-icon>
                                        </button>
                                        <button app-small-ghost-button class="app-button-alert"
                                                [disabled]="!communityDeletable"
                                                (click)="onClickDeleteCommunity()">
                                            <app-icon name="fal-trash-alt"></app-icon>
                                        </button>
                                    </div>
                                </div>
                                <div fxLayout="row" *ngIf="representative && representative.show">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Representative name'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4">
                                        {{ representative.name ? representative.name : ('No representative assigned'|i18n) }}
                                    </div>
                                </div>
                                <div fxLayout="row">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Activation date'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4" *ngIf="isDefined(ec.activation_date)">
                                        {{ ec.activation_date|i18nDate }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4" *ngIf="!isDefined(ec.activation_date)">
                                        <app-icon icon-color-w name="fas-exclamation-triangle"></app-icon>
                                    </div>
                                </div>
                                <div fxLayout="row">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Energy market zone'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4">
                                        {{ ec.zone }}
                                    </div>
                                </div>
                                <div fxLayout="row">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Mode'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4">
                                        <ng-container *ngIf="ecMode">
                                            <span class="mr-10">{{ ecMode|ecMode|i18n }}</span>
                                            <ng-container [ngSwitch]="ecMode">
                                                <app-icon *ngSwitchCase="ECMode.BASE" name="fas-info-circle"
                                                          [title]="'All community energy measures are based on statistical profiles'|i18n">
                                                </app-icon>
                                                <app-icon *ngSwitchCase="ECMode.ADVANCED" name="fas-info-circle"
                                                          [title]="'All PODs in the community are monitored by smart meters'|i18n">
                                                </app-icon>
                                                <app-icon *ngSwitchCase="ECMode.HYBRID" name="fas-info-circle"
                                                          [title]="'Energy data for some PODs are derived from smart meter monitoring, while others are based on statistical profiles'|i18n">
                                                </app-icon>
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="!ecMode">
                                            <span class="mr-10">{{ "Undefined__{f}"|i18n }}</span>
                                            <app-icon name="fas-info-circle"
                                                      [title]="'In the absence of resources, the nature of energy data cannot be defined.'|i18n">
                                            </app-icon>
                                        </ng-container>
                                    </div>
                                </div>

                                <div fxLayout="row">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Exchange POD'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4">
                                        {{ statistics?.pods }}
                                    </div>
                                </div>
                                <div fxLayout="row">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Plants'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4">
                                        {{ statistics?.plants }}
                                    </div>
                                </div>
                                <div fxLayout="row">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Creation date'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4">
                                        {{ isDefined(ec.created_on) ? (ec.created_on|i18nDate) : ('No date assigned'|i18n) }}
                                    </div>
                                </div>
                                <div fxLayout="row">
                                    <div fxFlex="50" class="txt-p-14-7">
                                        {{ ('Last modified date'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="50" class="txt-p-14-4">
                                        {{ isDefined(ec.modified_on) ? (ec.modified_on|i18nDate) : ('No date assigned'|i18n) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="!communitySelected" fxLayout="column" fxLayoutGap="20px"
                     class="ec-resources-param-panel" fxFlex>
                    <div class="ml-10 mt-10">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <app-icon [name]="resource|entityIcon" class="mr-12 resource-icon"></app-icon>
                            <div class="txt-h-24-7">{{ resource.name }}</div>
                        </div>
                        <div class="mt-12 txt-s-16-4">
                            {{ resource|entityType|i18n }}
                        </div>
                        <div *ngIf="(resource.holder || resource.owner) && !(isAdvUser|async)"
                             fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px" class="mt-16">
                            <div *ngIf="resource.holder?.id === resource.owner?.id"
                                 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                                <div>{{ 'Owner and holder'|i18n }}:</div>
                                <button app-small-ghost-button (click)="onClickGotoMember()">
                                    <app-icon name="fal-key"></app-icon>
                                    <app-icon name="fal-lightbulb"></app-icon>
                                    {{ mkMemberName(resource.holder) }}
                                </button>
                            </div>
                            <ng-container *ngIf="resource.holder?.id !== resource.owner?.id">
                                <div *ngIf="resource.holder" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                                    <div>{{ 'Holder'|i18n }}:</div>
                                    <button app-small-ghost-button (click)="onClickGotoMember()">
                                        <app-icon name="fal-lightbulb"></app-icon>
                                        {{ mkMemberName(resource.holder) }}
                                    </button>
                                </div>
                                <div *ngIf="resource.owner" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                                    <div>{{ 'Owner'|i18n }}:</div>
                                    <button app-small-ghost-button (click)="onClickGotoMember()">
                                        <app-icon name="fal-key"></app-icon>
                                        {{ mkMemberName(resource.owner) }}
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div fxLayout="column" class="ec-resources-param-box">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="txt-h-18-7">
                                {{ 'Technical details'|i18n }}
                            </div>
                            <div *ngIf="!(isAdvUser|async)" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px"
                                 class="mt-4">
                                <button app-small-ghost-button
                                        *ngIf="!!podResource"
                                        [title]="'Edit POD'|i18n"
                                        [disabled]="!canUpdateResource"
                                        (click)="onClickEditPod()">
                                    <app-icon class="fix-margin" name="fal-pencil-alt"></app-icon>
                                </button>
                                <button app-icon-button class="app-button-alert"
                                        *ngIf="!!podResource"
                                        [disabled]="!canDeleteResource"
                                        (click)="onClickDeletePod()">
                                    <app-icon name="fal-trash-alt"></app-icon>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="podResource || plantResource" fxLayout="column" class="mt-24" fxLayoutGap="20px">
                            <div *ngIf="podResource" fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Exchange POD'|i18n) + ':' }}
                                </div>
                                <div *appVar="podCode as podCode" fxFlex="60" class="txt-p-14-4">
                                    {{ podCode ? podCode : ('Undefined'|i18n) }}
                                </div>
                            </div>
                            <div *ngIf="plantResource" fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Production POD'|i18n) + ':' }}
                                </div>
                                <div *appVar="plantResource.production_pod as podCode" fxFlex="60" class="txt-p-14-4">
                                    {{ podCode ? podCode : ('Undefined'|i18n) }}
                                </div>
                            </div>
                            <div fxLayout="row" class="w-100" *ngIf="podResource">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Energy profile'|i18n) + ':' }}
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    {{ podEnergyProfile ? (podEnergyProfile|i18n) : ('Undefined'|i18n) }}
                                </div>
                            </div>
                            <div fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Voltage'|i18n) + ':' }}
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    <ng-container *ngIf="podResource">
                                        {{ getVoltage(podResource.voltage) ? (getVoltage(podResource.voltage)|i18n) : ('Undefined'|i18n) }}
                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        {{ getVoltage(plantResource.voltage) ? (getVoltage(plantResource.voltage)|i18n) : ('Undefined'|i18n) }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Phases'|i18n) + ':' }}
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    <ng-container *ngIf="podResource">
                                        {{ getPhase(podResource.phases) ? (getPhase(podResource.phases)|i18n) : ('Undefined'|i18n) }}
                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        {{ getPhase(plantResource.phases) ? (getPhase(plantResource.phases)|i18n) : ('Undefined'|i18n) }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    <ng-container *ngIf="podResource">
                                        {{ ('Contractual power'|i18n) + ':' }}
                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        {{ ('Nominal power'|i18n) + ':' }}
                                    </ng-container>
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    <ng-container *ngIf="podResource">
                                        {{ isDefined(podResource.contractual_power) ? (podResource.contractual_power|niceValue:'W') : ('Undefined'|i18n) }}

                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        {{ isDefined(plantResource.nominal_power) ? (plantResource.nominal_power|niceValue:'kW') : ('Undefined'|i18n) }}
                                    </ng-container>
                                </div>
                            </div>
                            <div *ngIf="plantResource && (!resource.members || (relevantMember && relevantMember.participation_type !== ECMemberParticipationType.THIRD_PARTY_PRODUCER))"
                                 fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">{{ ('Capital grant'|i18n) + ':' }}</div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    {{
                                        isDefined(plantResource.capital_grant) ?
                                            ((plantResource.capital_grant * 100)|niceValue:'%') :
                                            'Undefined'|i18n
                                    }}
                                </div>
                            </div>
                            <ng-container *ngIf="plantResource">
                                <div fxLayout="row" class="w-100">
                                    <div fxFlex="40" class="txt-p-14-7">
                                        {{ ('Effective date'|i18n) + ':' }}
                                    </div>
                                    <div *ngIf="isDefined(plantResource.activation_date)" class="txt-p-14-4">
                                        {{ plantResource.activation_date|i18nDate }}
                                    </div>
                                    <app-icon *ngIf="!!plantsErrorsMap[resource.name]" icon-color-w
                                              name="fas-exclamation-triangle"
                                              [title]="'Missing activation date'|i18n">
                                    </app-icon>
                                    <div *ngIf="!isDefined(plantResource.activation_date) && !plantsErrorsMap[resource.name]"
                                         class="txt-p-14-4">-
                                    </div>
                                </div>
                                <div fxLayout="row" class="w-100">
                                    <div fxFlex="40" class="txt-p-14-7">
                                        {{ ('Incentive mode'|i18n) + ':' }}
                                    </div>
                                    <div fxFlex="60" class="txt-p-14-4">
                                        {{ plantResource.incentive_mode|genericPipe|i18n }}
                                    </div>
                                </div>
                            </ng-container>
                            <div fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Statistical profile'|i18n) + ':' }}
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    <ng-container *ngIf="podResource">
                                        <ng-container *ngIf="isDefined(podResource.statistical_profile)">
                                            <div fxLayout="column" fxLayoutGap="6px">
                                                <div>{{ statisticalProfileInfo }}</div>
                                                <div *ngIf="hasAbsorption(podResource)" fxLayout="row"
                                                     fxLayoutGap="4px">
                                                    <span class="txt-p-14-7">{{ ('Yearly estimated absorption'|i18n) + ':' }}</span>
                                                    <span>{{ getYearlyEstimatedAbsorption(podResource.statistical_profile)|niceValue:'kWh' }}</span>
                                                </div>
                                                <div *ngIf="hasInjection(podResource)" fxLayout="row" fxLayoutGap="4px">
                                                    <span class="txt-p-14-7">{{ ('Yearly estimated injection'|i18n) + ':' }}</span>
                                                    <span>{{ getYearlyEstimatedInjection(podResource.statistical_profile)|niceValue:'kWh' }}</span>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="!isDefined(podResource.statistical_profile)">
                                            {{ 'Undefined'|i18n }}
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        <ng-container *ngIf="isDefined(plantResource.statistical_profile)">
                                            <div fxLayout="column" fxLayoutGap="6px">
                                                <div>{{ statisticalProfileInfo }}</div>
                                                <div fxLayout="row" fxLayoutGap="4px">
                                                    <span class="txt-p-14-7">{{ ('Yearly estimated production'|i18n) + ':' }}</span>
                                                    <span>{{ getYearlyEstimatedProduction(plantResource.statistical_profile)|niceValue:'kWh' }}</span>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="!isDefined(plantResource.statistical_profile)">
                                            {{ 'Undefined'|i18n }}
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" class="w-100" *ngIf="podResource">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Monitored by smart meter'|i18n) + ':' }}
                                </div>
                                <div class="txt-p-14-4" *ngIf="monitoredPod">
                                    <app-icon name="fal-check-circle" class="mr-10 monitored-flag monitored"></app-icon>
                                    {{ podResource.meter_model ? (podResource.meter_model|meterModel) : ('Undefined'|i18n) }}
                                </div>
                                <div class="txt-p-14-4" *ngIf="!monitoredPod">
                                    <app-icon name="fal-times-circle" class="monitored-flag"></app-icon>
                                </div>
                                <!-- TODO -->
                                <!--                                <app-icon icon-color-a name="fas-exclamation-triangle" class="ml-10"-->
                                <!--                                          [title]="'The device does not appear to be configured correctly according to the POD parameters. Therefore, the displayed data may be inconsistent.'|i18n">-->
                                <!--                                </app-icon>-->
                            </div>
                            <div *ngIf="!podResource || podEnergyProfile !== EnergyProfiles.PRODUCER"
                                 fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Predictive model'|i18n) + ':' }}
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    <ng-container *ngIf="podResource">
                                        {{ predictiveModelType ? (predictiveModelType|predictiveModelType|i18n) : ('Undefined'|i18n) }}
                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        {{ predictiveModelType ? (getPlantPredictiveModelType(predictiveModelType)|i18n) : ('Undefined'|i18n) }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Creation date'|i18n) + ':' }}
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    <ng-container *ngIf="podResource">
                                        {{ podResource.created_on ? (podResource.created_on|i18nDate) : ('No date assigned'|i18n) }}
                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        {{ plantResource.created_on ? (plantResource.created_on|i18nDate) : ('No date assigned'|i18n) }}
                                    </ng-container>
                                </div>
                            </div>
                            <div fxLayout="row" class="w-100">
                                <div fxFlex="40" class="txt-p-14-7">
                                    {{ ('Last modified date'|i18n) + ':' }}
                                </div>
                                <div fxFlex="60" class="txt-p-14-4">
                                    <ng-container *ngIf="podResource">
                                        {{ podResource.modified_on ? (podResource.modified_on|i18nDate) : ('No date assigned'|i18n) }}
                                    </ng-container>
                                    <ng-container *ngIf="plantResource">
                                        {{ plantResource.modified_on ? (plantResource.modified_on|i18nDate) : ('No date assigned'|i18n) }}
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!!aggregations.length" class="ec-resources-aggregations-panel" fxFlex="50">
                    <app-ec-measure-aggregations [refreshFrequency]="AGGREGATION_REFRESH_FREQUENCY"
                                                 [aggregations]="aggregations">
                    </app-ec-measure-aggregations>
                    <div *ngIf="resource.type === EntityType.ENERGY_COMMUNITY && plantsErrors?.length > 0"
                         fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" economics-warning
                         class="mt-30">
                        <app-icon icon-color-w name="fas-info-circle"></app-icon>
                        <div *ngIf="plantsErrors.length === 1">{{ 'There is {0} plant with no activation date. Fill in the date to count the plant in Economics.'|i18n:plantsErrors.length }}</div>
                        <div *ngIf="plantsErrors.length > 1">{{ 'There are {0} plants with no activation date. Fill in the date to count the plants in Economics.'|i18n:plantsErrors.length }}</div>
                        <button app-ghost-button class="warning-button"
                                (click)="onClickShowPods()"
                                [title]="'Plants with missing activation date'|i18n">
                            <app-icon name="fas-info-circle" class="ml-12"></app-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="plannableResource && planningNetwork" class="ec-resources-optimization-panel">
                <div fxLayout="row" fxLayoutAlign="start center" class="mb-20">
                    <app-icon name="fal-calendar-alt" class="optimization-icon mr-16"></app-icon>
                    <div class="txt-h-24-7">{{ 'Optimization'|i18n }}</div>
                </div>
                <app-plannings [network]="planningNetwork">
                </app-plannings>
            </div>
            <div *ngIf="predictableResource && forecastResource" class="ec-resources-prediction-panel">
                <div fxLayout="row" fxLayoutAlign="start center" class="mb-20">
                    <app-icon name="fal-binoculars" class="prediction-icon mr-16"></app-icon>
                    <div class="txt-h-24-7">{{ 'Resource forecasts'|i18n }}</div>
                </div>
                <app-forecasts [resource]="forecastResource">
                </app-forecasts>
            </div>
        </div>
    </div>
</div>

<ng-template #deletePod let-close="close">
    <ng-container *ngIf="resource.members.length == 0">
        <div fxLayout="row" fxLayoutAlign="center center" class="txt-a-18-7">
            {{ 'Warning: this action cannot be undone'|i18n }}
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-36">
            {{ 'By deleting this resource, you will also delete any plants and data associated to it.'|i18n }}
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
            <button app-ghost-button (click)="close('cancel')">
                {{ 'No, cancel'|i18n }}
            </button>
            <button app-primary-button (click)="close('delete')">
                {{ 'Yes, confirm'|i18n }}
            </button>
        </div>
    </ng-container>
    <ng-container *ngIf="resource.members.length > 0">
        <div fxLayout="row" fxLayoutAlign="center center" class="txt-a-18-7">
            {{ 'Warning: some members are connected to this resource'|i18n }}
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-36">
            {{ 'To delete this POD resource, you must delete the members attached to it.'|i18n }}
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
            <button app-ghost-button (click)="close('cancel')">
                {{ 'No, cancel'|i18n }}
            </button>
            <button app-primary-button (click)="close('members')">
                {{ 'Go to Members'|i18n }}
            </button>
        </div>
    </ng-container>
</ng-template>

<ng-template #editCommunity let-data let-close="close">
    <div class="edit-community app-dialog-background">
        <div fxLayout="column" fxLayoutGap="0.5rem" class="map-dialog">
            <app-ec-editor [community]="data.community"
                           [hierarchyEntity]="data.hierarchyEntity"
                           (saved)="onClickUpdateCommunity($event,close)">
            </app-ec-editor>
        </div>
    </div>
</ng-template>

<ng-template #deleteCommunity let-close="close">
    <div class="ml-42 mr-42 t-center">
        {{ ('Are you sure you want to delete'|i18n) }}<strong>{{ ' ' + resource.name }}</strong>{{ '?' }}<br>
        {{ 'In this way the community, its subjects, and its resources will be erased.'|i18n }}
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" app-dialog-actions>
        <button app-ghost-button (click)="close(false)">
            {{ 'No, cancel'|i18n }}
        </button>
        <button app-primary-button (click)="close(true)">
            {{ 'Yes, confirm'|i18n }}
        </button>
    </div>
</ng-template>

<ng-template #createPod let-data let-close="close">
    <div [style.width]="window.innerWidth*0.9+'px'" class="create-pod">
        <div fxLayout="column" fxLayoutGap="0.5rem" class="map-dialog">
            <app-ec-pod-creator-wizard
                    [ec]="data.ec"
                    (closeDialog)="close()"
                    (podResource)="onPodUpserted($event)">
            </app-ec-pod-creator-wizard>
        </div>
    </div>
</ng-template>
<ng-template #editPod let-data let-close="close">
    <div [style.width]="window.innerWidth*0.9+'px'" class="create-pod">
        <div fxLayout="column" fxLayoutGap="0.5rem" class="map-dialog">
            <app-ec-pod-creator-wizard
                    [ec]="data.ec"
                    [pod]="data.pod"
                    [member]="data.member"
                    (closeDialog)="close()"
                    (podResource)="onPodUpserted($event)">
            </app-ec-pod-creator-wizard>
        </div>
    </div>
</ng-template>


<ng-template #showPods let-close="close">
    <div class="txt-h-24-7">{{ 'Plants with missing activation date'|i18n }}:</div>
    <ul>
        <li *ngFor="let plantsErrorEntry of plantsErrorsMap | keyvalue" class="txt-h-16-4">
            {{ plantsErrorEntry.key }}
        </li>
    </ul>
    <div fxLayout="row" fxLayoutAlign="center center" app-dialog-actions>
        <button app-ghost-button (click)="close()">
            {{ 'Close'|i18n }}
        </button>
    </div>
</ng-template>
